import React, { useEffect } from 'react';
import Routes from './app/routes/appRoutes';
import { ToastContainer } from 'react-toastify';
import { Bounce } from 'react-toastify';
import { PWAUpdateDialog } from './shared/components/PWAUpdateDialog';
import { MotionProvider } from './shared/motion';
import { useAppDispatch } from './app/hooks';
import { logout } from './features/Auth/authSlice';
import {
  AUTH_BROADCAST_CHANNEL_NAME,
  clearSession,
} from './shared/utils/clearSession';


const App: React.FC = () => {
  const dispatch = useAppDispatch();

  // Cross-tab logout: when one tab tears down a session it broadcasts a
  // `logout` message via BroadcastChannel('hh-auth'). Every other tab in the
  // same origin receives it here and tears down its own per-tab state
  // (Redux, React Query cache, sessionStorage). `broadcast: false` prevents
  // an infinite ping-pong between tabs.
  useEffect(() => {
    if (typeof BroadcastChannel === 'undefined') return;

    const channel = new BroadcastChannel(AUTH_BROADCAST_CHANNEL_NAME);
    const handleMessage = (event: MessageEvent<{ type?: string }>) => {
      if (event.data?.type !== 'logout') return;
      dispatch(logout());
      void clearSession({ broadcast: false });
    };
    channel.addEventListener('message', handleMessage);
    return () => {
      channel.removeEventListener('message', handleMessage);
      channel.close();
    };
  }, [dispatch]);

  return (
    <MotionProvider>
      <Routes />
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      {/* PWA Update Dialog - renders globally when new version available */}
      <PWAUpdateDialog debug/>
    </MotionProvider>
  );
};

export default App;
